import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { IGeneralCondition } from '../../model/general-condition.model';
import { API_CORE } from '../../constant/api-core.const';
import { IPresignedURL } from '../../model/presigned-url.model';
import { IPresignedGeneralConditionAttachment } from '../../model/presigned-general-condition-attachment.model';
import { IGeneralConditionAttachment } from '../../model/general-condition-attachment.model';

@Injectable({
  providedIn: 'root',
})
export class GeneralConditionService {
  async getGeneralCondition(
    airlineBrandCode?: string,
    originCountry?: string,
    destinationCountry?: string,
    originCode?: string,
    destinationCode?: string,
    chargeableWeight?: number,
    product?: string,
  ): Promise<IGeneralCondition[]> {
    const extraOptions: any = {
      queryParams: {},
    };
    if (airlineBrandCode) {
      extraOptions.queryParams.airline = airlineBrandCode;
    }
    if (originCountry) {
      extraOptions.queryParams.originCountry = originCountry;
    }
    if (destinationCountry) {
      extraOptions.queryParams.destinationCountry = destinationCountry;
    }
    if (originCode) {
      extraOptions.queryParams.origin = originCode;
    }
    if (destinationCode) {
      extraOptions.queryParams.destination = destinationCode;
    }
    if (chargeableWeight) {
      extraOptions.queryParams.chargeableWeight = chargeableWeight;
    }
    if (product) {
      extraOptions.queryParams.product = product;
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.GeneralCondition.GeneralConditions,
      extraOptions,
    );
  }

  async createOrUpdateGeneralCondition(
    generalCondition: IGeneralCondition,
  ): Promise<IGeneralCondition> {
    return CaiApi.post(
      API_CORE.name,
      API_CORE.URLs.GeneralCondition.GeneralConditions,
      {
        body: generalCondition,
      },
    );
  }
  async generateUploadUrlForAttachment(
    generalConditionId: number,
    attachment: IGeneralConditionAttachment,
  ): Promise<IPresignedGeneralConditionAttachment> {
    const url = API_CORE.URLs.GeneralCondition.UploadAttachment.replace(
      '{generalConditionId}',
      generalConditionId.toString(),
    );
    return CaiApi.post(API_CORE.name, url, {
      body: attachment,
    });
  }
  async generateDownloadUrlForAttachment(
    generalConditionId: number,
    generalConditionAttachmentId: number,
    token?: string,
  ): Promise<IPresignedURL> {
    const url = API_CORE.URLs.GeneralCondition.DownloadAttachment.replace(
      '{generalConditionId}',
      generalConditionId.toString(),
    )
      .concat('/')
      .concat(generalConditionAttachmentId.toString());
    let extraOptions = {};
    if (token) {
      extraOptions = {
        queryParams: { token },
      };
    }
    return CaiApi.get(API_CORE.name, url, extraOptions);
  }
  async deleteAttachment(
    generalConditionId: number,
    generalConditionAttachmentId: number,
  ): Promise<any> {
    const url = API_CORE.URLs.GeneralCondition.DeleteAttachment.replace(
      '{generalConditionId}',
      generalConditionId.toString(),
    )
      .concat('/')
      .concat(generalConditionAttachmentId.toString());
    return CaiApi.del(API_CORE.name, url, {});
  }
}
